import { Box } from '@mui/material';
import React, { useMemo } from 'react';

import { Banner } from './Banner';
import { useTargetUserIdBanners } from './useTargetUserIdBanners';
import { useTargetUserTypesBanners } from './useTargetUserTypesBanners';

type AllBannersProps = React.ComponentProps<typeof Box>;

export const AllBanners = ({ sx, ...props }: AllBannersProps) => {
  const targetUserIdBanners = useTargetUserIdBanners();
  const targetUserTypesBanners = useTargetUserTypesBanners();

  const banners = useMemo(
    () => [...targetUserIdBanners, ...targetUserTypesBanners],
    [targetUserIdBanners, targetUserTypesBanners],
  );

  if (banners.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: '100%', mx: 'auto', display: 'flex', flexDirection: 'column', gap: '1rem', ...sx }} {...props}>
      {banners.map((banner) => (
        <Banner
          key={banner.id}
          title={banner.title}
          description={banner.description}
          colour={banner.colour || 'info'}
          updatedAt={banner.updatedAt}
          bannerId={banner.id}
          nonDismissable={banner.nonDismissable}
        />
      ))}
    </Box>
  );
};
